import { reduxForm, clearSubmitErrors } from "redux-form";
import Form from "./Form";
import formName from "./formName";

export default reduxForm({
  formName,
  form: formName,
  onChange: (values, dispatch, props) => {
    if (props.error) dispatch(clearSubmitErrors(formName));
  },
})(Form);
